export default function getFilteredCitiesList(data, inputvalue) {
  if (!data) return '';
  if (!inputvalue) return '';

  const filteredCitiesList = data
    ?.filter(i => i?.toLowerCase()?.startsWith(inputvalue?.toLowerCase()))
    ?.slice(0, 10);

  if (filteredCitiesList?.length === 0) return null;
  return filteredCitiesList;
}
